import { defaultLanguage } from '@/constants/localization/localization.constans'
import { createI18n } from 'vue-i18n'
const i18n = createI18n({
    locale: defaultLanguage,
    globalInjection: true,
    messages: {}
  });

const $t = i18n.global.t;
export { i18n, $t };